import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { CONTACT_US_IF_FURTHER_HELP, getAccountSettingsCTA } from "./shared";

export const PasswordIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getAccountSettingsCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getAccountSettingsCTA(context, strictLocalize)?.getLink?.();
      },
    },
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => UPDATE_PASSWORD_TITLE(strictLocalize),
    getDescription: () => [
      UPDATE_PASSWORD_DESCRIPTION_1(strictLocalize),
      UPDATE_PASSWORD_DESCRIPTION_2(strictLocalize),
      CONTACT_US_IF_FURTHER_HELP(strictLocalize),
    ],
  };
};

const UPDATE_PASSWORD_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Update Password",
    description: {
      text: "Title for the answer of updating password",
    },
  });

const UPDATE_PASSWORD_DESCRIPTION_1 = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "If you would like to reset your password, please follow the steps below:",
  });

const UPDATE_PASSWORD_DESCRIPTION_2 = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "Click the Sign In button in the top right corner of the homepage. Type in your login email address and press enter on the next screen, click the link that says “Forgot your password? Reset It“.",
  });
